import React, { useState, useEffect } from 'react';
import { useNavigate, useParams  } from 'react-router-dom';
import Loader from './Loader';
import Header from './Header';
import { getDataFromFirestore, updateProjectInFirestore } from '../firebaseService';
function EditProject({ user, setUser }) {
    const navigate = useNavigate();
    const { id } = useParams()
    const numericId = parseInt(id, 10);
  const [loading, setLoading] = useState(false);
    const [projects, setProjects] = useState([]);
   
    const saveProj = async (id) => {
      setLoading(true);
      const updatedProjects = projects.map((p) => {
        return p.id === id ? { ...p, data: p.data } : p
      }).filter(p=>p.id===numericId);
     await  updateProjectInFirestore(id, updatedProjects[0]);
     setLoading(false);
      navigate('/my-projects');
    }
     

    const handleEditProj = (e) => {
      const { name, value } = e.target;
      const updatedProjects = projects.map((p) => {
        return p.id === numericId ? { ...p, data: { ...p.data, [name]: value } } : p
      });
      setProjects(updatedProjects);
    }
    useEffect(() => {
      setLoading(true);
      getDataFromFirestore().then((data) => { 
        data && setProjects(data)
      })
      setLoading(false);
    }, []);
    
     useEffect(() => {
        // Redirect to "/" after logout
       if(!user) navigate('/');
      }, [navigate,user]);
    
     const userProjects = projects.filter(item => numericId === item.id);
   
      return (
        <div>
              <Header user = {user} setUser = {setUser} />
                   {loading ? <Loader/> : <><h2>Редагувати проєкт</h2>
                    <div className="canvas-container">
          {userProjects.length > 0 ? (
            userProjects.map((project, index) => (
            <div key={index}>
            <div  className="canvas-grid">
                <div className="grid-item name">  Назва соціального проєкту:  <textarea name='name' onChange={handleEditProj} value={project.data.name}  /> </div>
               <div className="grid-item problem"> <span>Проблема користувачів, яку вирішуємо: </span> <textarea onChange={handleEditProj}  name = 'problem' value={project.data.problem}  /></div>
              <div className="grid-item customer_segments"><span>Сегменти користувачів:</span> <textarea onChange={handleEditProj} name='customer_segments' value={project.data.customer_segments}  /></div>
              <div className="grid-item unique_value"><span>Унікальна цінність:</span> <textarea onChange={handleEditProj} name = "unique_value_proposition" value= {project.data.unique_value_proposition} /></div>
              <div className="grid-item solution"><span>Вирішення проблеми:</span> <textarea onChange={handleEditProj} name = "solution" value={project.data.solution} /></div>
              <div className="grid-item channels"><span>Канали:</span> <textarea onChange={handleEditProj} name = "channels" value={project.data.channels}/></div>
              <div className="grid-item cost_structure"><span>Структура витрат:</span> <textarea onChange={handleEditProj} name = "cost_structure" value={project.data.cost_structure}/></div>
              <div className="grid-item revenue_streams"><span>Прибуток:</span> <textarea onChange={handleEditProj} name = "revenue_streams" value={project.data.revenue_streams}/></div>
              <div className="grid-item key_metric"><span>Ключові метрики:</span> <textarea onChange={handleEditProj} name = "key_metrics" value={project.data.key_metrics}/></div>
              <div className="grid-item unfair_advan"><span>Неринкова перевага:</span> <textarea onChange={handleEditProj} name="unfair_advantage" value={project.data.unfair_advantage}/></div>
                   </div>
            <button onClick={()=>saveProj(numericId)} className="print-button" >Зберігти зміни</button>
              </div>
          ))
          ): (
            <p className="no-projects-message">У вас немає проєктів. Створіть новий, щоб почати.</p>
          )
        }
        </div></> }
                   
                    
        </div>
      )
    };


export default EditProject
